<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'user.title' | translate }}</h4>
      <p class="mb-0">{{ 'user.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'user.detailsHeader' | translate }}
            </h4>

            <!-- UserId -->
            <div class="form-group">
              <label>{{ 'user.userIdFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="userId"
                     placeholder="{{'user.userIdFieldPlaceHolder' | translate}}" [readOnly]="true">
            </div>

            <!-- UserName -->
            <div *ngIf="currentObject.UserId" class="form-group">
              <label>{{ 'user.userNameFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="userName"
                     placeholder="{{'user.userNameFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly || currentObject.UserId">
            </div>

            <!-- FirstName -->
            <div class="form-group">
              <label>{{ 'user.firstNameFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="firstName"
                     placeholder="{{'user.firstNameFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly">
            </div>

            <!-- LastName -->
            <div class="form-group">
              <label>{{ 'user.lastNameFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="lastName"
                     placeholder="{{'user.lastNameFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly">
            </div>

            <!-- Email -->
            <div class="form-group">
              <label>{{ 'user.emailFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="email"
                     placeholder="{{'user.emailFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly || currentObject.UserId">
            </div>

            <!-- PhoneNumber -->
            <div class="form-group">
              <label>{{ 'user.phoneNumberFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="phoneNumber"
                     placeholder="{{'user.phoneNumberFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly">
            </div>

            <!-- Function -->
            <div class="form-group">
              <label>{{ 'user.functionFieldLabel' | translate }}</label>
              <input class="form-control" type="text" formControlName="function"
                     placeholder="{{'user.functionFieldPlaceHolder' | translate}}"
                     [readOnly]="currentObject.IsReadOnly">
            </div>

            <!-- TwoFactorSetupEnabled -->
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" formControlName="twoFactorSetupEnabled">
              <label for="TwoFactorSetupEnabled"
                     class="custom-control-label">{{ 'user.twoFactorSetupEnabledLabel' | translate }}</label>
            </div>
            <br>

            <!-- TwoFactorEnabled -->
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" formControlName="twoFactorEnabled"
                     disabled="disabled">
              <label for="TwoFactorEnabled"
                     class="custom-control-label">{{ 'user.twoFactorEnabledLabel' | translate }}</label>
            </div>
            <br>

            <!-- Company Selection -->
            <app-company-selection-list [active]="hasSelectCompanyPermission && !currentObject.IsReadOnly"
                                        [label]="'user.selectCompanyLabel' | translate"
                                        [(selectedCompany)]="currentObject.Company"
                                        [selectCompanyText]="'user.selectCompanyPlaceHolder' | translate"
                                        (companyChangedEvent)="handleCompanyChanged($event)"></app-company-selection-list>

            <!-- User Group Selection -->
            <app-user-group-selection-list [active]="hasSelectUserGroupPermission && !currentObject.IsReadOnly"
                                           [label]="'user.selectUserGroupLabel' | translate"
                                           [(selectedUserGroupCode)]="currentObject.UserGroupCode"
                                           [selectUserGroupText]="'user.selectUserGroupPlaceHolder' | translate"
                                           (userGroupChangedEvent)="handleUserGroupChanged($event)"></app-user-group-selection-list>

            <!-- Module Selection -->
            <app-module-selection
              title="{{'user.modules.title' | translate}}"
              [noModulesAvailableMessage]="'user.modules.noModulesAvailableMessage' | translate"
              sourceUrl="/module/user"
              [(userId)]="currentObject.UserId"
              [(companyId)]="currentObject.CompanyId">
            </app-module-selection>
          </div>
          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-warning mr-1" type="button" (click)="resetForm(form)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [disabled]="!form.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
              <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
